<template>
	<v-text-field
		v-model="localSearchString"
		hide-details
		single-line
		height="36"
		data-lpignore="true"
		outlined
		class="srch step_s mx-2 mt-3"
		placeholder="Search"
		append-icon="mdi-magnify"
	></v-text-field>
</template>

<script>
export default {
	name: 'SearchField',
	props: {
		searchString: { type: String },
	},
	computed: {
		localSearchString: {
			get() {
				return this.searchString;
			},
			set(value) {
				this.$emit('update:searchString', value);
			},
		},
	},
};
</script>

<style scoped lang="scss">
.step_s.srch.v-text-field {
	::v-deep {
		fieldset {
			background: #f9f9fa;
		}
		.v-input__append-inner {
			margin-top: 8px !important;
			color: #93a1ba !important;

			i {
				color: #93a1ba !important;
				font-size: 20px;
				font-weight: 300;
			}
		}
	}
}
</style>
